import { render, staticRenderFns } from "./newPlatformSample.vue?vue&type=template&id=88edca16&"
import script from "./newPlatformSample.vue?vue&type=script&lang=js&"
export * from "./newPlatformSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports